module.exports = __webpack_public_path__ + "img/yellow-shape.18d0feff.svg";